export default "__VITE_PUBLIC_ASSET__7487fc08__"